import Sources from "./../Enum/Sources"

export default class Source {
    constructor(id) {
        const dir = new Sources();
        const item = dir.items[id - 1];
        
        Object.assign(this, item);
    }
}